(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["royful-mix"] && !Shopify.designMode) return;
  try {
    
function initRoyfulMix(){
document.querySelectorAll('.royful-mix').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const money=new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:root.dataset.currency||'CAD'});
function update(){
let sum=0,count=0,pending=false;
root.querySelectorAll('[data-product]').forEach(row=>{
if(!row.querySelector('[data-pick]').checked||row.querySelector('[data-pick]').disabled)return;
count++;
const input=row.querySelector('[data-quantity]');
const quantity=Math.min(99,Math.max(1,Math.floor(Number(input.value)||1)));
const price=Number(row.dataset.price);
if(price<=0)pending=true;
sum+=price*quantity;
});
const rate=count>=5?10:count>=3?5:0;
const savings=Math.round(sum*rate/100);
const net=sum-savings;
const progress=root.querySelector('[data-shipping-progress]');
const progressMessage=root.querySelector('[data-progress-message]');
if(pending){
progress.value=0;
progressMessage.textContent=root.dataset.progressPending;
}else{
progress.value=Math.min(7500,Math.max(0,net));
progressMessage.textContent=net>=7500?root.dataset.progressComplete:root.dataset.progressRemaining.replace('{amount}',money.format((7500-net)/100));
}
root.querySelector('[data-original]').textContent=pending?root.dataset.pending:money.format(sum/100);
root.querySelector('[data-savings]').textContent=pending?root.dataset.pending:money.format(savings/100);
root.querySelector('[data-total]').textContent=pending?root.dataset.pending:money.format((sum-savings)/100);
const status=count>=5?root.dataset.tierTop:count>=3?root.dataset.tierHigh:root.dataset.tierLow;
root.querySelector('[data-message]').textContent=status.replace('{remaining}',String(count<3?3-count:Math.max(0,5-count))).replace('{rate}',String(rate));
root.querySelector('[data-shipping]').textContent=root.dataset.shippingRule+' '+(!pending&&sum-savings>=7500?root.dataset.shippingReached:root.dataset.shippingPending);
const upgrade=root.querySelector('[data-upgrade]');
upgrade.textContent='';
if(!pending&&(count===2||count===4)){
const candidates=Array.from(root.querySelectorAll('[data-product]')).filter(row=>!row.querySelector('[data-pick]').checked&&!row.querySelector('[data-pick]').disabled&&Number(row.dataset.price)>0);
candidates.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
if(candidates.length){
const next=candidates[0],newRate=count===4?10:5,nextSubtotal=sum+Number(next.dataset.price),nextTotal=nextSubtotal-Math.round(nextSubtotal*newRate/100);
upgrade.textContent=root.dataset.upgrade.replace('{item}',next.dataset.name).replace('{rate}',String(newRate)).replace('{amount}',money.format((nextTotal-(sum-savings))/100)).replace('{saved}',money.format(Math.round(nextSubtotal*newRate/100)/100));
}
}
}
root.addEventListener('input',update);
root.addEventListener('change',update);
update();
});
}
initRoyfulMix();
document.addEventListener('shopify:section:load',initRoyfulMix);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royful-promo"] && !Shopify.designMode) return;
  try {
    
function measureRoyfulPromo(){
const bar=document.getElementById('shopify-section-royful-promo');
if(!bar)return;
const measure=()=>document.documentElement.style.setProperty('--royful-promo-height',Math.ceil(bar.getBoundingClientRect().height)+'px');
measure();
if(bar.dataset.measured)return;
bar.dataset.measured='true';
new ResizeObserver(measure).observe(bar);
}
measureRoyfulPromo();
document.addEventListener('shopify:section:load',measureRoyfulPromo);

  } catch(e) { console.error(e); }
})();
})();
